/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { UserResponseDocumentTheme } from './userResponseDocumentTheme';

export interface UserResponse {
  id: string;
  org_id?: string | null;
  email: string;
  first_name: string;
  last_name: string;
  avatar_url?: string | null;
  phone?: string | null;
  timezone: string;
  role: string;
  is_active: boolean;
  email_verified: boolean;
  onboarding_completed?: boolean;
  onboarding_step?: number;
  last_login_at?: string | null;
  document_theme?: UserResponseDocumentTheme;
  created_at: string;
  updated_at: string;
}
